import React, { useState } from "react";
import { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CourseBlock from "./CourseBlock";
import { leftArrow, rightArrow } from "../../../constants/icons";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import CourseBundleDescription from "./CourseBundleDescription";
import CourseAccordion from "./CourseAccordion";

function CourseCarousel() {
  
  const items = [
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '1',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '2',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '3',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '4',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '5',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '6',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '7',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '8',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '9',
    },
    {
      name: 'The Complete JS Course 2022: From Zero to Expert!',
      content: '10',
    }
  ];

  const ref = useRef(null);

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };

  const [selectedItem, setSelectedItem] = useState(null);

  const handleClick = (item) => {
    setSelectedItem(item);
    console.log(selectedItem, item);
  }

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    adaptiveHeight: true,
  };

  return (
    <>
      <div className="carousel-action">
        <a href="#" className="btn-move btn-prev" onClick={handlePrevSlide}>
          {leftArrow}
        </a>{" "}
        <a href="#" className="btn-move btn-next" onClick={handleNextSlide}>
          {rightArrow}
        </a>
      </div>
      <Slider  className="carousel-course-bundle myui-slider" {...settings} ref={ref}>
        {items.map(item => (
          <div key="{item.id}">
            <CourseBlock className={JSON.stringify(item) === JSON.stringify(selectedItem) ? 'active' : ''} carouselImage={SampleImage2} carouselTitle={item.name} courseDetails="Duis aute irure dolor in reprehenderit in voluptae velit esse cillum dolore eu fu" courseLectures="6 Lectures" onClick={() => handleClick(item)}/>
          </div>
        ))}
      </Slider>
      {selectedItem && (
        <>
          <CourseBundleDescription className="mt-4" courseBundleDescTitle={`${selectedItem.content} PMP Exam Prep Seminar - 35 Complete Exam Coverage`} courseBundleDesc="The HIPAA Basics course will introduce you to the Health Insurance Portability and Accountability Act of 1996 or HIPAA in a simple yet informative way. This course also focuses on helping the learner gain an understanding of the following topics:"/>
          <CourseBundleDescription className="mt-4" courseBundleDescTitle="Curriculum" />
          <CourseAccordion />
        </>
      )}
    </>
  );
}

export default CourseCarousel;
